import ImagesFabMainModal from '@/modules/adjusterReportModules/adjusterReport/components/imagesFab/ImagesFabMainModal';
import PartTwoCulprit from '@/modules/adjusterReportModules/IncidentParticipants/components/vehicleInformation/components/partTwo/forms/PartTwoCulprit/PartTwoCulprit';
import PartTwoDamaged from '@/modules/adjusterReportModules/IncidentParticipants/components/vehicleInformation/components/partTwo/forms/PartTwoDamaged/PartTwoDamaged';
import { VehicleInformationEnum } from '@/modules/adjusterReportModules/IncidentParticipants/types/VehicleInformationType';

const VehicleInformationPartTwoWrapper = ({
  type,
}: {
  type: VehicleInformationEnum;
}) => {
  return type === VehicleInformationEnum.culprit ? (
    <>
      <PartTwoCulprit />
      <ImagesFabMainModal state={'propertyCulprit'} />
    </>
  ) : (
    <>
      <PartTwoDamaged />
      <ImagesFabMainModal state={'propertyDamaged'} />
    </>
  );
};
export default VehicleInformationPartTwoWrapper;
